import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AutentificacionService } from '../_services/autentificacion.service';
import { NavController } from '@ionic/angular';

export const jwtGuard: CanActivateFn = (route, state) => {
  const authService = inject(AutentificacionService);
  const navCtrl = inject(NavController);

  const usuario = authService.userInfo;
  if (!usuario || !usuario.token) {
    navCtrl.navigateRoot('/login');
    return false;
  }
  return true;
};
